<template>
    <div class="main">
        <img :src="require('../../assets/bg.jpg')" class="bg_main"/>
        <div class="mainBox">
            <div class="main_header">
                 <div class="main_1">
                     <div class="main_1_left">
                         <h2></h2>
                     </div>
                     <div class="main_1_right">
                         <div class="timeclear">
                             {{time}}
                             <!-- <el-date-picker
                             v-model="timeval"
                                format="yyyy-MM-dd hh:mm:ss"
                                type="date"
                                :clearable="false"
                               @change="onChange"
                                >
                             </el-date-picker> -->
                         </div>
                         <div class="backHome"><router-link to="energy"><img :src="require('../../assets/arro.png')" />返回首页</router-link> </div>
                     </div>
                 </div>
            </div>  
            <div class="main_body">
                <div class="main_2">
                    <div class="main_2_1">
                        <van-tabs v-model="active" background="transparent" line-width='0' @click="onTabClick">
                          <van-tab title="昨日排行">
                              <div class="content" @click="handleClick($event,2)" >
                                  <vueSeamlessScroll :data="objtotal.lists" :class-option="defaultOption" class="seamless-warp" v-if="isroll">
                                      <ul class="textlist2">
                                          <li @click="onClick(item)"
                                          v-for="(item,index) in objtotal.lists" :key="index"
                                          :class="'on'+(index+1)"
                                          >
                                              <div class="info" :data-item="JSON.stringify(item)">
                                                  <span :data-item="JSON.stringify(item)">TOP{{index+1}}</span>
                                                  <p :data-item="JSON.stringify(item)">{{item.username}}</p>
                                              </div>
                                              
                                              <div class="thingregcode" :data-item="JSON.stringify(item)">{{item.totaltask}}车</div>
                                              <div class="thingstatus" :data-item="JSON.stringify(item)"
                                              :class="item.thingstatus==20?'n20':item.thingstatus==18?'n18':item.thingstatus==10?'n10':item.thingstatus==1?'n1':item.thingstatus==15?'n15':item.thingstatus==17?'n17':''"
                                              >
                                                  {{item.totalfinishweight}}吨
                                              </div>
                                          </li>
                                      </ul>
                                  </vueSeamlessScroll>
                                  
                              </div>
                          </van-tab>
                          <van-tab title="累计排行">
                              
                              <div class="content" @click="handleClick($event,2)">
                                  <vueSeamlessScroll :data="objtotal.listtotal" :class-option="defaultOption" class="seamless-warp" v-if="isroll">
                                      <ul class="textlist2">
                                          <li @click="onClick(item)"
                                          v-for="(item,index) in objtotal.listtotal" :key="index"
                                          :class="'on'+(index+1)"
                                          >
                                              <div class="info" :data-item="JSON.stringify(item)">
                                                  <span :data-item="JSON.stringify(item)">TOP{{index+1}}</span>
                                                  <p :data-item="JSON.stringify(item)">{{item.username}}</p>
                                              </div>
                                              <div class="thingregcode" :data-item="JSON.stringify(item)">{{item.totaltask}}车</div>
                                              <div  class="thingstatus" :data-item="JSON.stringify(item)"
                                              :class="item.thingstatus==20?'n20':item.thingstatus==18?'n18':item.thingstatus==10?'n10':item.thingstatus==1?'n1':item.thingstatus==15?'n15':item.thingstatus==17?'n17':''"
                                              >
                                                  {{item.totalfinishweight}}吨
                                              </div>
                                          </li>
                                      </ul>
                                  </vueSeamlessScroll>
                              </div>
                          </van-tab>
                        </van-tabs>
                    </div>
                    <div class="main_2_2">
                        <div class="main_2_2_1">
                            <ul class="textlist">
                                <li v-for="(item,index) in list1" :key="index" :class="'n'+index ">
                                    <div class="picture">
                                        <div class="img1">
                                            <img :src="require('../../assets/icon1.png')"/>
                                        </div>
                                        <div class="img2">
                                            <img :src="require('../../assets/icon2.png')"/>
                                        </div>
                                    </div>
                                    <div class="info">
                                        <span>
                                            <b>
                                            {{objtotal.totalObj[item.parentfield]&&objtotal.totalObj[item.parentfield][item.field]?objtotal.totalObj[item.parentfield][item.field]:0}}</b>
                                            {{item.unit}}
                                        </span>
                                        <p>{{item.text}}</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="main_2_2_2">
                            <div class="main_2_2_2_1">
                                <div class="wrap">
                                    <div class="title">
                                        <div class="picture">
                                            <img :src="objtotal.taskobj&&objtotal.taskobj.useravatar_link?objtotal.taskobj.useravatar_link:require('../../assets/head.png')"/>
                                        </div>
                                        <div class="info">
                                            <p>
                                                {{objtotal.taskobj?objtotal.taskobj.username:'--'}}
                                                <b>{{objtotal.taskobj?objtotal.taskobj.usermobile:'--'}}</b>
                                                <span @click="onshow(1)" v-if="objtotal.curobj&&!show1">
                                                    <img :src="require('../../assets/track.png')"/>轨迹回放
                                                </span>
                                            </p>
                                            <span>{{objtotal.taskobj?objtotal.taskobj.thingregcode:'--'}}</span>
                                            
                                        </div>
                                        
                                    </div>
                                    <div class="content" >
                                        <div class="content3" v-if='objtotal.curobj'>
                                            <p>行驶总时长：{{objtotal.curobj.vehicleduration}}小时</p>
                                            <p>里程：{{objtotal.curobj.vehiclemileage}}</p>
                                        </div>
                                        <div class="content1" v-if='objtotal.taskdata'>
                                            <p>出发地：{{objtotal.taskdata.taskfromname}}</p>
                                            <img :src="require('../../assets/arrowR.png')"/>
                                            <p>目的地：{{objtotal.taskdata.tasktoname}}</p>
                                        </div>
                                        <div class="content2" v-if='objtotal.taskdata'>
                                            <p>装货：{{objtotal.taskdata.startweightreal}}吨</p>
                                            <p v-if='objtotal.taskdata.finishweightreal&&objtotal.taskdata.finishweightreal>0'>卸货：{{objtotal.taskdata.finishweightreal}}吨</p>
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="wrap1" v-if='ismap'>
                                    暂无车辆GPS数据
                                </div>
                                <div class="container"  ref="qqMap" ></div>
                                <div class="wrap wrap2" v-if='$route.query.thingpower==2'>
                                    <div class="title">
                                        <img :src="require('../../assets/cardid.png')"/>充电统计
                                        <!-- 电卡卡号：{{objtotal.cardobj&&objtotal.cardobj.outcardno?objtotal.cardobj.outcardno:'暂无'}} -->
                                        <span @click="onshow(2)">查看详情</span>                        
                                    </div>
                                    <div class="content">
                                        <span>月累计充电电量：{{objtotal.cardobjM&&objtotal.cardobjM.month.totalpowersum?objtotal.cardobjM.month.totalpowersum:0}}</span>
                                        <span>月累计充电次数：{{objtotal.cardobjM&&objtotal.cardobjM.month.ordercnt?objtotal.cardobjM.month.ordercnt:0}}次</span>
                                        <span>月累计充电费用：{{objtotal.cardobjM&&objtotal.cardobjM.month.totalmoneysum?objtotal.cardobjM.month.totalmoneysum:0}}元</span>
                                        <span>昨日充电电量：{{objtotal.cardobj&&objtotal.cardobj.today.totalpowersum?objtotal.cardobj.today.totalpowersum:0}}</span>
                                        <span>昨日充电次数：{{objtotal.cardobj&&objtotal.cardobj.today.ordercnt?objtotal.cardobj.today.ordercnt:0}}次</span>
                                        <span>昨日充电费用：{{objtotal.cardobj&&objtotal.cardobj.today.totalmoneysum?objtotal.cardobj.today.totalmoneysum:0}}元</span>
                                    </div>
                                </div>
                            </div>
                            <div class="main_2_2_2_2">
                                <div class="main_2_2_2_2_1">
                                    <div class="title"><img :src="require('../../assets/title6.png')"/></div>
                                    <div class="content">
                                        <div id="main3" class="main"></div>
                                    </div>
                                </div>
                                <div class="main_2_2_2_2_2">
                                    <div class="title"><img :src="require('../../assets/title7.png')"/></div>
                                    <div class="content">
                                        <div id="main2" class="main"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mask_main" style="z-index:2000 !important" @click="handleClose" v-if="show1||show2"></div>
        <el-dialog
          title=" "
          :visible.sync="show1"
          class="track_pup popup_main"
          :show-close="false"
          width="100%"
          top='0'
          :modal="false"
          :destroy-on-close="true"
          @opened="dialogOpened"
          :before-close="handleClose">
              <div class="track_1">
                  <div class="title"><img :src="require('../../assets/detail_pup1.png')"/></div>
              </div>
              <div class="track_2">
                  <div class="track_2_1">
                      <div class="time_1">
                          <span class="label">回放开始时间</span>
                          <el-date-picker
                            v-model="startsyncdate"
                            popper-class="timepicker"
                            class="syncdate"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                          <el-time-picker
                              v-model="startsynctime"
                              popper-class="timepicker"
                              class="synctime"
                              value-format="HH:mm:ss"
                              placeholder="请选择时间">
                            </el-time-picker>
                      </div>
                      <div class="time_2">
                          <span class="label">回放结束时间</span>
                          <el-date-picker
                            v-model="endsyncdate"
                            popper-class="timepicker"
                            class="syncdate"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                          <el-time-picker
                              v-model="endsynctime"
                              popper-class="timepicker"
                              value-format="HH:mm:ss"
                              class="synctime"
                              placeholder="请选择时间">
                            </el-time-picker>
                      </div>
                      <div class="time_3">
                          <button @click="onSubimit(1)">查询</button>
                      </div>
                  </div>
                  <div class="track_2_2">
                      <div class="container" ref="qqMap1" ></div>
                  </div>
          </div>
          
        </el-dialog>
        <el-dialog
          title=" "
          :visible.sync="show2"
          class="track_pup popup_main"
          :show-close="false"
          width="100%"
          top='0'
          :modal="false"
          :destroy-on-close="true"
          :before-close="handleClose">
                <div class="track_1">
                    <div class="title"><img :src="require('../../assets/detail_pup2.png')"/></div>
                </div>
                <div class="track_2 charg_2">
                  <div class="track_2_1">
                      <div class="time_1">
                          <span class="label">时间选择</span>
                          <el-date-picker
                                v-model="orderdate"
                                type="daterange"
                                popper-class="timepicker"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="dateOptionsPicker"
                                value-format="yyyy-MM-dd"
                                >
                          </el-date-picker>
                          
                      </div>
                      <div class="time_3">
                          <button @click="onSubimit(2)">查询</button>
                      </div>
                  </div>
                  <div class="track_2_2 charg_2_2">
                      <div class="tip">
                          <p>站点名称</p><p>开始时间</p><p>结束时间</p><p>充电度数</p><p>合计金额</p><p>服务费</p>
                      </div>
                      <div class="wrap">
                          <ul class="textlist3">
                              <li
                              v-for="(item,index) in objtotal.cardlist" :key="index"
                              :class="'on'+(index+1)"
                              >
                                <span>{{item.stationname?item.stationname:'--'}}</span>
                                <span>{{item.starttime?item.starttime:'--'}}</span>
                                <span>{{item.endtime?item.endtime:'--'}}</span>
                                <span>{{item.totalpower?item.totalpower:'--'}}</span>
                                <span>{{item.totalmoney?item.totalmoney:'--'}}</span>
                                <span>{{item.sevicemoney?item.sevicemoney:'--'}}</span>
                                
                              </li>
                          </ul>
                      </div>
                  </div>
                </div>
          
        </el-dialog>
    </div>
    
    </template>
<script>
    import Qs from 'qs';
    import { Toast,Tab, Tabs} from 'vant';
    import vueSeamlessScroll from "vue-seamless-scroll";
    export default {
        name: '',
        components: {
            vueSeamlessScroll,
            [Toast.name]:Toast,
            [Tab.name]:Tab,
            [Tabs.name]: Tabs,
        },
        data() {
            return {
                list1:[
                    {img:require('../../assets/sk/icon1.png'),text:'昨日运输重量',parentfield:'today',field:'finishweightsum',unit:'吨',type:1},
                    {img:require('../../assets/sk/icon2.png'),text:'昨日运输车次',parentfield:'today',field:'taskcnt',unit:'车',type:1},
                    {img:require('../../assets/sk/icon3.png'),text:'本月运输重量',parentfield:'month',field:'finishweightsum',unit:'吨',type:1},
                    {img:require('../../assets/sk/icon4.png'),text:'本年运输重量',parentfield:'year',field:'finishweightsum',unit:'吨',type:1},
                    {img:require('../../assets/sk/icon5.png'),text:'累计运输重量',parentfield:'total',field:'finishweightsum',unit:'吨',type:2},
                ],
                obj: '',
                widths: window.screen.width,
                active:this.$route.query.type=='2'?1:0,
                main1Chart: null,
                main2Chart: null,
                main3Chart: null,
                objtotal:{
                    today:{},
                    total:{},
                    totalObj:{},
                    lists:[],
                    listtotal:[],
                    mylist:[],
                    mylisttotal:[],
                    thingtotal:0,
                    ylfxdata: [],
                    taskdata:[],
                    taskobj:'',
                    userid:'',
                    thingid:'',
                    vehicle:[],
                    curobj:'',
                    cardobj:'',
                    cardobjM:'',
                    cardlist:[]
                },
                time: this.$formatime(new Date().getTime(), 'ymdhms', 'now'),
                timeval: this.$formatime(new Date().getTime()-24*60*60*1000, 'ymd', 'now'),
                
                //地图
                marker : null,
                infoWindow: null,
                map: null,
                ismap:true,
                
                
                //滚动
                defaultOption : {
                    step: 0.3,
                    limitMoveNum: 17,
                    // singleHeight: 20,
                    waitTime: 2000 ,
                    hoverStop:true,
                    // navigation:true,
                    openTouch:true,
                    switchSingleStep:true
                },
                isroll:true,
                //轨迹弹窗
                show1:false,
                marker1:null,
                infoWindow1: null,
                map1: null,
                ismap1:true,
                marker2 : null,
                polylineLayer:null,
                startsyncdate:this.$formatime(new Date().getTime() - 3600 * 1000 * 24, 'ymd', 'now'), //开始日期
                startsynctime:'00:00:00', //开始时间
                endsyncdate:this.$formatime(new Date().getTime(), 'ymd', 'now'), //结束日期
                endsynctime:this.$formatime(new Date().getTime(), 'hms', 'now'), //结束时间
                
                //电量详情
                dateOptionsPicker: {disabledDate(time) {return time.getTime() > Date.now() - 8.64e6}},
                show2:false,
                orderdate:[this.$formatime(new Date().getTime() - 3600 * 1000 * 24, 'ymd', 'now'),this.$formatime(new Date().getTime(), 'ymd', 'now')]
            }
        },
        created() {
            this.objtotal.userid=this.$route.query.userid;
            this.objtotal.thingid=this.$route.query.thingid;
        },
        mounted() {
            this.initMap(0);
            var that = this;
            window.addEventListener("resize", () => {
                that.widths = window.screen.width;
                // that.initMap(2);
                that.isroll=false;
                that.show1=false;
            })
        },
        methods: {
            dialogOpened(){
                console.log(2222)
                var center = new TMap.LatLng(39.984104, 116.307503);//设置中心点坐标
                this.map1 = new TMap.Map(this.$refs.qqMap1, {
                    center: center,
                    mapStyleId: 'style3',
                    zoom:14,
                    // showControl:false,
                });
                this.onSubimit(1)
                // console.log(this.map1)
                // if(this.objtotal.curobj.maplat>0){
                //     this.map1.setCenter(new TMap.LatLng(this.objtotal.curobj.maplat,this.objtotal.curobj.maplng));
                //     var list=[];
                //     list.push(this.objtotal.curobj)
                //     this.setQQMap(list,4)
                // }
            },
            onSubimit(type){
                if(type==1){
                    var _that = this;
                    let object = {
                        url: 'd=wxapi&c=emp_thing_super&m=history_list',
                        data: {
                            vehiclecode:this.objtotal.curobj.vehiclecode,
                            startsyncdate: this.startsyncdate,
                            startsynctime: this.startsynctime,
                            endsyncdate: this.endsyncdate,
                            endsynctime:this.endsynctime,
                        },
                        target: 'wuliu',
                        success: res => {
                            var result = res.data;
                            if(_that.marker1){
                                _that.marker1.setMap(null);
                                _that.infoWindow1.setMap(null);
                            }
                            if(_that.marker2){
                                _that.marker2.setMap(null);
                            }
                            
                            _that.setmark(result.rows);
                        },
                        complete: res => {
                            
                        }
                    }
                    this.$getData(object);
                }else{
                    this.setCardDetail();
                }
                
            },
            setmark(list){
                var _that=this;
                var path=[];
                this.map1.setCenter(new TMap.LatLng(list[0].vehiclelat,list[0].vehiclelng));
                this.map1.setZoom(15);
                for(var i=0;i<list.length;i++){
                    path.push(new TMap.LatLng(list[i].vehiclelat, list[i].vehiclelng))
                }
                if(this.polylineLayer!=null)
                {
                    this.polylineLayer.setMap(null);
                }
                this.polylineLayer = new TMap.MultiPolyline({map:this.map1, // 绘制到目标地图
                  // 折线样式定义
                  styles: {
                    style_blue: new TMap.PolylineStyle({
                      color: '#3777FF', // 线填充色
                      width: 4, // 折线宽度
                      borderWidth: 2, // 边线宽度
                      borderColor: '#FFF', // 边线颜色
                      lineCap: 'round', // 线端头方式
                      eraseColor: 'rgba(190,188,188,1)',
                    }),
                  },
                  geometries: [
                    {
                      id: 'erasePath',
                      styleId: 'style_blue',
                      paths: path,
                    },
                  ],
                });          
                this.marker2 = new TMap.MultiMarker({ 
                    map:this.map1,
                    styles: {
                        'car-down': new TMap.MarkerStyle({
                          width: 40,
                          height: 40,
                          anchor: {
                            x: 20,
                            y: 20,
                          },
                          faceTo: 'map',
                          rotate: 180,
                          src: require('../../assets/car_online1.png'),
                        }),
                        start: new TMap.MarkerStyle({
                          width: 25,
                          height: 35,
                          anchor: { x: 16, y: 32 },
                          src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/start.png',
                        }),
                        end: new TMap.MarkerStyle({
                          width: 25,
                          height: 35,
                          anchor: { x: 16, y: 32 },
                          src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/end.png',
                        }),
                    },
                  geometries: [
                    {
                      id: 'car',
                      styleId: 'car-down',
                      position: path[0],
                    },
                    {
                      id: 'start',
                      styleId: 'start',
                      position: path[0],
                    },
                    {
                      id: 'end',
                      styleId: 'end',
                      position: path[path.length-1],
                    },
                  ],
                });
                this.marker2.moveAlong(
                    {
                      car: {
                        path,
                        duration: 30000,
                      },
                    },
                    {autoRotation: true,}
                );
                this.marker2.on('moving', (e) => {
                    var passedLatLngs = e.car && e.car.passedLatLngs;
                    if (passedLatLngs) {
                      // 使用路线擦除接口 eraseTo, https://lbs.qq.com/webApi/javascriptGL/glDoc/glDocVector
                      this.polylineLayer.eraseTo(
                        'erasePath',
                        passedLatLngs.length - 1,
                        passedLatLngs[passedLatLngs.length - 1]
                      );
                    }
                });
            },
            onshow(type){
                if(type==1){
                    this.show1=true;
                }else if(type==2){
                    this.show2=true;
                    this.setCardDetail();
                }
                
            },
            handleClose(type){
                this.show1=false;
                this.show2=false;
            },
            // onChange(val){
            //     this.timeval=this.$formatime(val.getTime(), 'ymd', 'now');
            //     this.time=this.$formatime(val.getTime(), 'ymdhms', 'now');
            //     this.getTaskTotal(1);
            // },
            onClick(item){
                if(this.timer){
                    clearInterval(this.timer);
                }
                this.objtotal.userid=item.userid;
                this.objtotal.thingid=item.thingid;
                this.initMap(3,item);
                this.ismap=true;
                
            },
            onClick1(item){
                if(this.timer){
                    clearInterval(this.timer);
                }
                this.objtotal.userid=item.userid;
                this.objtotal.thingid=item.thingid;
                this.initMap(3,item);
                this.ismap=true;
                
            },
            handleClick(e,type){
                let target=e.target;
                this.onClick1(JSON.parse(target.dataset.item) ,type)
            },
            onTabClick(index){
                this.isroll=false;
                if(this.active==1){
                    this.getUsertotal();
                }else{
                    this.getUser(4);
                    
                }
            },
            initMap(type,item) {
                if (this.$store.state.configdata) {
                    if(type!=1&&type!=2&&type!=3){
                        var center = new TMap.LatLng(39.984104, 116.307503);//设置中心点坐标
                        this.map = new TMap.Map(this.$refs.qqMap, {
                            center: center,
                            mapStyleId: 'style3',
                            zoom:16,
                            showControl:false,
                        });
                    }else if(type==3){
                        this.objtotal.mylist=[];
                        this.objtotal.mylisttotal=[];
                        this.objtotal.mylist.push(item);
                        this.objtotal.mylisttotal.push(item);
                    }
                    var _that = this;
                    let object = {
                        url: 'd=wxapi&c=emp_thing_super&m=vehicle_page',
                        data: {
                            rows:1000,
                            thingpower:this.$route.query.thingpower==2?2:1,
                        },
                        target: 'wuliu',
                        success: res => {
                            var result = res.data;
                            if(_that.marker&&_that.infoWindow){
                                _that.marker.setMap(null);
                                _that.infoWindow.setMap(null);
                            }
                            var lits=[];
                            
                            result.rows.forEach(item=>{
                                if(item.thingid==_that.objtotal.thingid){
                                    
                                    _that.objtotal.curobj=item;
                                    lits.push(item);
                                    _that.map.setCenter(new TMap.LatLng(item.maplat,item.maplng));
                                    _that.ismap=false;
                                }
                            })
                            _that.setQQMap(lits,type);
                            // _that.settime()
                        },
                        complete: res => {
                            _that.getTaskTotal(type);
                        }
                    }
                    this.$getData(object);
                }
            },
            getTaskTotal(type) {
                var _that = this;
                let object = {
                    url: 'd=wxapi&c=emp_task_super&m=task_total',
                    data: {
                        today:this.timeval,
                        totaltype:'today,month,year,total',
                        userid:this.objtotal.userid,
                        thingpower:this.$route.query.thingpower==2?2:1,
                    },
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        _that.objtotal.totalObj=result;
                        _that.objtotal.ylfxdata=[
                            { value: result.today.finishweightsum?result.today.finishweightsum:0,itemStyle: {color:'#22C570'}, name: '昨日运量'},
                            { value: result.month.finishweightsum?result.month.finishweightsum:0, itemStyle:{color:'#FFDD43'},name: '本月运量'},
                            { value: result.year.finishweightsum?result.year.finishweightsum:0,itemStyle: {color:'#1CF2FF'},name: '本年运量'}
                        ]
                        
                        // this.setChart1(_that.objtotal.ylfxdata,type)
                    },
                    complete: res => {
                        _that.taskTotal(type);
                    }
                }
                this.$getData(object); 
            },
            
            taskTotal(type) {
                var _that = this;
                let object = {
                    // url: 'd=wxapi&c=emp_task_super&m=task_total',
                    url:'d=wxapi&c=emp_total&m=task_total',
                    data: {
                        today:this.timeval,
                        thingid: this.objtotal.thingid,
                        // userid:this.objtotal.userid,
                        thingpower:this.$route.query.thingpower==2?2:1,
                        totaltype: 'day7',
                        rows:7
                    },
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        _that.objtotal.chart2data=result.day7
                        _that.setChart2(result.day7,type,2);
                        _that.setChart2(result.day7,type,3);
                    },
                    complete: res => {
                        _that.billPage(type);
                    }
                }
                this.$getData(object);
            },
            billPage(type){
                var _that = this;
                let object = {
                    url: 'd=wxapi&c=emp_task_super&m=bill_page',
                    data: {
                        thingid: this.objtotal.thingid,
                        rows:1,
                        thingpower:this.$route.query.thingpower==2?2:1,
                    },
                    // islogin:true,
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        _that.objtotal.taskdata=result.rows[0];
                    },
                    complete: res => {
                        _that.getThing();
                    }
                }
                this.$getData(object);
            },
            getThing(type){
                var _that = this;
                let object = {
                    url:'d=wxapi&c=emp_thing_super&m=thing_byid',
                    data: {
                        thingid: this.objtotal.thingid,
                        rows:1,
                        thingpower:this.$route.query.thingpower==2?2:1,
                    },
                    // islogin:true,
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        _that.objtotal.taskobj=result;
                    },
                    complete: res => {
                        if(type!=3){
                            _that.getUser(type);
                        }else{
                            // Toast.clear();
                        }
                        _that.getCard();
                    }
                }
                this.$getData(object);
            },
            getUser(type) {
                var _that = this;
                let object = {
                    url: 'd=wxapi&c=emp_task_super&m=task_group',
                    data: {
                        groupby: 'userid',
                        thingpower:this.$route.query.thingpower==2?2:1,
                        taskdate:this.timeval?this.timeval:this.$formatime(new Date().getTime(), 'ymd', 'now')
                    },
                    // islogin:true,
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        _that.objtotal.lists=result.rows;
                        result.rows.forEach((item,index)=>{
                            _that.objtotal.mylist=[];
                            if(item.userid==_that.objtotal.userid){
                                var obj=Object.assign({},item,{rank:(index+1)});
                                _that.objtotal.mylist.push(obj)
                            }
                        })
                       
                    },
                    complete: res => {
                        if(type<4){
                            _that.getUsertotal(type);
                        }else{
                            _that.isroll=true;
                        }
                    }
                }
                this.$getData(object);
            },
            getUsertotal(type) {
                console.log(111)
                var _that = this;
                let object = {
                    url: 'd=wxapi&c=emp_task_super&m=task_group',
                    data: {
                        groupby: 'userid',
                        rows:'20',
                        thingpower:this.$route.query.thingpower==2?2:1,
                    },
                    // islogin:true,
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        console.log(result)
                        _that.objtotal.listtotal=result.rows;
                        _that.objtotal.mylisttotal=[];
                        result.rows.forEach((item,index)=>{
                            if(item.userid==_that.objtotal.userid){
                                var obj=Object.assign({},item,{rank:(index+1)})
                                _that.objtotal.mylisttotal.push(obj)
                            }
                        })
                        this.isroll=true;
                    },
                    complete: res => {
                        
                    }
                }
                this.$getData(object);
            },
            getCard(){
                if(this.$route.query.thingpower=='2'){
                    var _that = this;
                    let object = {
                        url: 'd=wxapi&c=emp_total&m=evcs_total',
                        data: {
                            thingid:this.objtotal.curobj.thingid,
                            totaltype:'today',
                            today:this.timeval?this.timeval:this.$formatime(new Date().getTime(), 'ymd', 'now')
                        },
                        // islogin:true,
                        target: 'wuliu',
                        success: res => {
                            var result = res.data;
                            _that.objtotal.cardobj=result;
                        },
                        complete: res => {
                            _that.getCardM();
                        }
                    }
                    this.$getData(object);
                }
            },
            getCardM(){
                if(this.$route.query.thingpower=='2'){
                    var _that = this;
                    let object = {
                        url: 'd=wxapi&c=emp_total&m=evcs_total',
                        data: {
                            thingid:this.objtotal.curobj.thingid,
                            totaltype:'month',
                            month:this.$formatime(new Date().getTime(), 'ym', 'now')
                        },
                        // islogin:true,
                        target: 'wuliu',
                        success: res => {
                            var result = res.data;
                            _that.objtotal.cardobjM=result;
                        },
                        complete: res => {
                            
                        }
                    }
                    this.$getData(object);
                }
            },
            setCardDetail(){
                var _that = this;
                let object = {
                    url: 'd=wxapi&c=emp_evcs_order&m=order_page',
                    data: {
                        thingid:this.objtotal.curobj.thingid,
                        rows:1000,
                        orderdate:this.orderdate[0]+','+this.orderdate[1]
                    },
                    // islogin:true,
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        _that.objtotal.cardlist=result.rows;
                    },
                    complete: res => {
                        
                    }
                }
                this.$getData(object);
            },
            
            settime(type) {
                
                let _that = this;
                var countdown = 30;
                if(this.timer){
                    clearInterval(this.timer);
                    this.timer=null;
                }
                this.timer = setInterval(function() {
                    if (countdown) {
                        countdown--
                        if(!_that.timeval){
                            _that.time = _that.$formatime(new Date().getTime(), 'ymdhms', 'now')
                        }
                    } else {
                        clearInterval(_that.timer);
                        if(!_that.timeval){
                            _that.time = _that.$formatime(new Date().getTime(), 'ymdhms', 'now');
                        }
                        _that.initMap(1);
                    }
                }, 1000)
            },
            
            setQQMap(result,type) {
                
                var list=[];
                for (var i = 0; i < result.length; i++) {
                    var data=result[i];
                    // var warn=data.vehiclewarn?parseInt(data.vehiclewarn):0;
                    // var obj={
                    //     "id": data.thingid,
                    //     "styleId": 'marker',
                    //     "position": new TMap.LatLng(data.maplat,data.maplng),
                    //     "rotate":360-Number(data.vehicledirection),		
                    //     "content":data.thingregcode,
                    //     "speed": data.vehiclespeed,
                    //     "style":warn.toString(2).substr(-2,1)=='1'?2:data.thingstatus=='15'||data.thingstatus=='18'||data.thingstatus=='20'?3:1
                    // }
                    var warn=data.vehiclewarn?parseInt(data.vehiclewarn):0;
                    var strobj=this.$getPoliceType(warn,data);
                    var obj = {
                        "id": data.thingid,
                        "styleId": 'marker',
                        "position": new TMap.LatLng(data.maplat, data.maplng),
                        "rotate": 360 - Number(data.vehicledirection),
                        "content": data.thingregcode,
                        "speed": data.vehiclespeed,
                        "userid": data.userid,
                        "style":strobj.isred?2:strobj.isyellow?3:1,
                        'text':strobj.text,
                        "maxZoom":20,
                    }
                    list.push(obj)
                    this.createMarker(obj,type); 
                }
                // if(type!=1&&list.length>0){
                //     var bounds = new TMap.LatLngBounds();
                //     list.forEach(item=>{
                //         //若坐标点不在范围内，扩大bounds范围
                //         if(bounds.isEmpty() || !bounds.contains(item.position)){
                //             bounds.extend(item.position);
                //         }
                //     })
                //     //设置地图可视范围
                //     this.map.fitBounds(bounds, {
                //         padding: this.setfontSize(100) // 自适应边距
                //     });
                // }
                
            },
            createMarker(data,type) {
                var _that=this;
                if(type==4){
                    
                    this.marker1=new TMap.MultiMarker({
                        id: data.id,
                        map: _that.map1,
                        styles: {
                            "marker": new TMap.MarkerStyle({
                                "width": _that.setfontSize(30),
                                "height": _that.setfontSize(30),
                                "anchor": { x: _that.setfontSize(30/2), y: _that.setfontSize(30/2) },
                                "src": require('../../assets/car_online'+data.style+'.png'),
                                color: '#000',
                                direction: 'bottom',
                                size: _that.setfontSize(14),
                                strokeColor: '#ff0',
                                rotate: data.rotate,
                            })
                        },
                        geometries: [{
                            "id": data.id,
                            "styleId": 'marker',
                            "position": data.position,
                            "properties": {
                                "title": data.id
                            },
                        }]
                    });
                    this.infoWindow1=new TMap.InfoWindow({
                        map: _that.map1,
                        enableCustom: true,
                        position: data.position,
                        offset: { x: 0, y: _that.setfontSize(-15) }, //设置信息窗相对position偏移像素
                        content: "<div class='infowindow'><p>"+data.content+"</p><p>"+data.speed+"公里/小时</p></div>"
                    })
                }else{
                    this.marker=new TMap.MultiMarker({
                        id: data.id,
                        map:_that.map,
                        styles: {
                            "marker": new TMap.MarkerStyle({
                                "width": _that.setfontSize(30),
                                "height": _that.setfontSize(30),
                                "anchor": { x: _that.setfontSize(30/2), y: _that.setfontSize(30/2) },
                                "src": require('../../assets/car_online'+data.style+'.png'),
                                color: '#000',
                                direction: 'bottom',
                                size: _that.setfontSize(14),
                                strokeColor: '#ff0',
                                rotate: data.rotate,
                            })
                        },
                        geometries: [{
                            "id": data.id,
                            "styleId": 'marker',
                            "position": data.position,
                            "properties": {
                                "title": data.id
                            },
                        }]
                    });
                    this.infoWindow=new TMap.InfoWindow({
                        map:_that.map,
                        enableCustom: true,
                        position: data.position,
                        offset: { x: 0, y: _that.setfontSize(-15) }, //设置信息窗相对position偏移像素
                        content: "<div class='infowindow'> <p>" + data.content + "</p><p>" + data.speed +
                            "公里/小时</p>"+data.text+"</div>"
                    })
                }
                
            },
            setChart1(data,type){
                if(type==1||type==3){
                    this.main1Chart.setOption({
                        series:[{data:data}],
                    })
                    this.main1Chart.resize();
                }else if(type==2){
                    this.main1Chart.resize();
                }else{
                    this.main1Chart = this.$echarts.init(document.getElementById('main1'));
                    var option = {
                      tooltip: {
                        trigger: 'item'
                      },
                      grid: {
                          // top: '2%',
                          left: '3%',
                          right: '4%',
                          bottom: '3%',
                          containLabel: true
                      },
                      series: [
                        {
                          name: 'Access From',
                          type: 'pie',
                          radius: ['60%', '90%'],
                          
                          avoidLabelOverlap: false,
                          label: {
                              normal: {
                                  show: false,
                                  position: 'outer',
                                  alignTo: 'edge',
                                  color:'#fff',
                                  formatter: '{name|{b}}'+ '\n\r' + '{num|{d}%}',
                                  rich: {
                                      name:{
                                          fontSize:  this.setfontSize(12),
                                          color:'#fff'
                                      },
                                      num: {
                                          fontSize:  this.setfontSize(14),
                                          color:'#fff',
                                          lineHeight:this.setfontSize(30),
                                      },
                                  }
                              },
                          },
                          bottom:20,
                          top:20,
                          data: data
                        }
                      ]
                    };
                    this.main1Chart.setOption(option);
                }
            },
            setChart2(items,type,id){
                var xdata=[],weightdata=[],taskcntdata=[];
                items.forEach((item,index)=>{
                    xdata.push(item.taskdate);
                    weightdata.push(item.finishweightsum);
                    taskcntdata.push(item.taskcnt);
                })
                var titletip='';
                if(items.length>0){
                    titletip={
                        text: ""
                    }
                }else{
                    titletip={
                        text: "暂无数据",
                         left: "center",
                         top: "center",
                         textStyle: {
                            fontSize: this.setfontSize(20),
                            color: '#fff'
                        }
                    }
                }
                if(type==1||type==3){
                    if(id==2){
                        this.main2Chart.setOption({
                            title:titletip,
                            series:[{data:weightdata}],
                            xAxis:{data: xdata,}
                        })
                        this.main2Chart.resize();
                    }else if(id==3){
                        this.main3Chart.setOption({
                            title:titletip,
                            series:[{data:taskcntdata}],
                            xAxis:{data: xdata,}
                        })
                        this.main3Chart.resize();
                    }
                }else if(type==2){
                    if(id==2&&this.main2Chart){
                        this.main2Chart.resize();
                    }else if(id==3&&this.main2Chart){
                        this.main3Chart.resize();
                    }
                }else{
                    if(id==2){
                        this.main2Chart = this.$echarts.init(document.getElementById('main2'));
                    }else if(id==3){
                        this.main3Chart = this.$echarts.init(document.getElementById('main3'));
                    }
                    
                    
                    var option = {
                        title:titletip,
                        grid: {
                            top: '10%',
                            left: '1%',
                            right: '2',
                            bottom: '6%',
                            containLabel: true
                        },
                        toolbox: {
                            show: true,
                        },
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            },
                            formatter: function (params) {
                                var htmlStr = '';
                                htmlStr += '<div><span style="color:#000;">' + params[0].axisValue + '</span><br/> ';
                                htmlStr += '<span style="width: 8px;height: 8px;margin-right:5px; display:inline-block;border-radius: 50%;background-color:'+params[0].color.value+'"></span>';
                                htmlStr += '<span style="color:#000;margin-right:20px">' + params[0].seriesName + '</span><span style="color:#000;font-weight:bold;">' + params[0].value + (id==2?" 吨":" 车")+'</span></div>';
                                return  htmlStr
                            },
                        },
                        
                        xAxis: {
                            type: 'category',
                            data: xdata,
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: "rgba(255,255,255,0.1)",
                                    width: 0,
                                    type: "solid"
                                }
                            },
                            axisLabel: { //x轴文字的配置
                                show: true,
                                interval:0,
                                rotate:30,
                                textStyle: {
                                    color: "#fff",
                                    fontSize: this.setfontSize(14)
                                },
                            },
                        },
                        yAxis: {
                            type: 'value',
                            splitLine: { //分割线配置
                                show: true,
                                lineStyle: {
                                    color: "rgba(255,255,255,0.1)",
                                }
                            },
                            axisLabel: { //
                                show: true,
                                textStyle: {
                                    color: "#aaa",
                                    fontSize: this.setfontSize(16)
                                }
                            },
                        },
                        series: [{
                            name: id==2?'运输重量':'运输车次',
                            type: 'bar',
                            barMaxWidth: this.setfontSize(30),
                            emphasis: {
                                focus: 'series'
                            },
                            backgroundStyle: {
                              color: '#4482FF'
                            },
                            itemStyle: {
                                color: {
                                    value:id==2?'rgba(246,147,0,1)':'rgba(64,158,255,1)',
                                    type: 'linear',
                                    x: 0, //右
                                    y: 0, //下
                                    x2: 0, //左
                                    y2: 1, //上
                                    colorStops: [
                                      {
                                        offset: 0,
                                        color: id==2?'rgba(246,147,0,1)':'rgba(64,158,255,1)' // 0% 处的颜色
                                      },
                                      {
                                        offset: 1,
                                        color: id==2?'rgba(246,147,0,0)':'rgba(64,158,255,0)' // 100% 处的颜色
                                      }
                                    ]
                                }   
                            },
                            label:{
                                show: true,
                                color: '#fff',
                                position: 'top',
                                fontSize: this.setfontSize(12),
                                formatter:id==2?"{c}吨":"{c}车",
                            },
                            data: id==2?weightdata:taskcntdata
                        }
                        ]
                    };
                    if(id==2){
                        this.main2Chart.setOption(option);
                    }else if(id==3){
                        this.main3Chart.setOption(option);
                    }
                }
            },
            
            setfontSize(res){
            	const clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
            	if (!clientWidth) return;
            	let fontSize = clientWidth / 1920;
            	return parseInt(res*fontSize) ;
            },
        },
        activated() {
        },
        destroyed(){
            if(this.timer){
                clearInterval(this.timer);
            }
        },
        watch: {
            '$store.state.configdata'(val, oldVal) {
                if (!oldVal) {
                    this.initMap(0);
                }
            }
        },
    }
</script>
<style scoped lang="less">
    @import '../../style/css/variable.less';
    ::v-deep{
        // .bg_main {
        //     position: fixed;
        //     height: 100%;
        //     width: 100%;
        //     top: 0;
        //     right: 0;
        //     object-fit: fill;
        //     // background: rgba(23, 74, 156, 1);
        //     z-index: 999;
        // }
        .bg_main{
                position: fixed;
                height: 100%;
                width: 100%;
                    top: 0;
                    right: 0;
        }
        .mainBox {
            
            position: fixed;
            left:0;
            z-index:999;
            top:0;
            width: 100%;
            background-size: 100% 100%;
            box-sizing: border-box;
            height: 100%;
            padding:0 20px 20px 20px;
            overflow: hidden;
            .flex-between();
            flex-flow: column;
            .main_header{
                width:100%;
                height: 8.8%;
                box-sizing: border-box;
               .main_1 {
                   position: relative;
                   height: 100%;
                   box-sizing: border-box;
                   .flex-center();
                   align-items: flex-start;
                   .main_1_left{
                       width:100%;height: 100%;
                       background: url('../../assets/top_bg1.png') no-repeat center;
                       background-size: 100%;
                       h2 {
                           display: block;
                           font-size: 40px;
                           color: #5AD2F8;
                           text-align: center;
                           margin-top: 10px;
                       }
                   }
                   .main_1_right {
                       position: absolute;
                       right:0;
                       top:12px;
                       .flex-between();
                       flex-flow: column;
                       align-items: flex-end;
                       .timeclear{
                           position: relative;
                           font-size: 14px;
                           color: #86A9D6;
                           position: relative;
                           
                           text-align: right;
                           .el-date-editor{
                               position: absolute;
                               left:50%;
                               top:50%;
                               transform: translate(-50%,-50%);
                               input{
                                   font-size: 0;
                                   border:none;
                                   background: none;
                                   color: #B3B5BD;
                               }
                           }
                       }
                       .backHome{
                           a{
                               margin:32px 0 0 0;
                               .flex-start();font-size: 20px;color: #fff;align-items: center;
                               img{width: 24px;display: block;margin-right: 9px;}
                           }
                       }
                   }
               } 
            }
            .main_body{
                width:100%;
                height:88.5%;
                
                box-sizing: border-box;
                .flex-between();
                flex-flow: column;
            }
            .main_2 {
                width:100%;
                height: 100%;
                box-sizing: border-box;
                .flex-between();
                .main_2_1{
                    width:22.34%;
                    height: 100%;
                    background: url(../../assets/main_2_1.png) no-repeat center;background-size:100% 100%;
                    position: relative;
                    .title{
                        border-bottom: 1px solid #00B6EF;box-sizing: border-box;
                        height:9.4%;
                    }
                    .content{
                        padding:0 20px;
                        box-sizing: border-box;
                        height:100%;
                        overflow: hidden;
                    }
                }
                .main_2_2{
                    width:77.03%;height: 100%;.flex-between();flex-flow: column;
                    
                    .main_2_2_1{
                        width:100%;
                        height: 16.35%;  
                        box-sizing: border-box;padding:0 0 0 28px;
                    }
                    .main_2_2_2{
                        .flex-between();
                        width:100%;
                        height:83.7%;
                        .main_2_2_2_1{
                            width:64.77%;
                            height: 100%;
                            position: relative;
                            background: linear-gradient(180deg, #051840 0%, #1445A8 100%);
                            box-shadow: inset 0px 0px 24px 1px #00B6EF;
                            border-radius: 0px 0px 0px 0px;
                            border: 1px solid #00B6EF;
                            .wrap{
                                position: absolute;left:36px;top:36px;
                                background: linear-gradient(58deg, #1445A8 0%, rgba(20,69,168,0) 100%);
                                padding: 0;
                                padding:20px 24px;.flex-center();flex-flow: column;border-left: 6px solid #1456DE;z-index: 1001;
                                .title{
                                    height: auto;
                                    width:100%;
                                    .flex-start();
                                    
                                    .picture{
                                        .flex-center();flex-flow: column;align-items: flex-start;overflow:hidden;
                                        img{
                                            width:60px;height:60px;border-radius:50%;
                                        }
                                        
                                    }
                                    .info{
                                        margin-left: 10px;.flex-center();flex-flow: column;align-items: flex-start;
                                        span{color:#fff;font-size: 16px;margin-top: 10px;}
                                        p{
                                            color:#fff;font-size: 16px;.flex-start();align-items: center;
                                            b{font-weight: normal;color:#fff;font-size: 12px;margin-left: 10px;}
                                            span{
                                                .flex-start();font-size: 14px;color: #fff;margin-left: 60px;margin-top: 0;cursor: pointer;
                                                img{display: block;width: 20px;margin-right: 4px;}
                                            }
                                        }
                                        
                                    }
                                    
                                }
                                .content{
                                    margin-top: 10px;width: 100%;
                                    .content1{
                                        margin-top: 10px;
                                        .flex-start();
                                        img{display: block;height: 18px;width:34px;margin:0 10px;}
                                        p{
                                            font-size: 16px;color:@white;line-height:1;
                                        }
                                    }
                                    .content2{
                                        margin-top: 10px;
                                        .flex-start();
                                        p{
                                            padding: 0 16px;height: 26px;font-size: 12px;color: #fff;line-height: 26px;margin-right: 20px;
                                            background: linear-gradient(94deg, #3972E8 0%, #1445A8 100%);border-radius: 16px;
                                        }
                                    }
                                    .content3{
                                        // margin-top: 10px;
                                        .flex-between();
                                        p{
                                           font-size: 16px;color:@white;line-height:1;
                                        }
                                    }
                                    
                                }
                                // opacity: 0.86;
                            }
                            .wrap1{
                                position: absolute;left:50%;top:50%;transform: translate(-50%,-50%);padding: 0;
                                width: 371px;height: 167px;.flex-center();color:#fff;font-size:20px;z-index: 999;
                                background: linear-gradient(180deg, rgba(5,24,64,0.8) 0%, rgba(20,69,168,0.8) 100%);
                                box-shadow: inset 0px 0px 24px 1px #4482FF;border-radius: 5px;
                            }
                            .wrap2{
                                position: absolute;left:36px;top:auto; bottom:35px;background: linear-gradient(58deg, #1445A8 0%, rgba(20,69,168,0) 100%);
                                padding: 0;z-index: 1001;padding:20px 24px;.flex-center();flex-flow: column;border-left: 6px solid #1456DE;
                                .title{
                                    .flex-start();font-size: 16px;color:@white;line-height:1;
                                    img{
                                        display: block;width: 24px;margin-right: 10px
                                    }
                                    span{
                                        background: rgba(246,147,0,0.8);font-size: 14px;padding: 4px 12px;color: #fff;border-radius: 5px;margin-left:20px;cursor: pointer;
                                    }
                                }
                                .content{
                                    .flex-start();flex-flow: wrap;
                                    span{
                                        margin-top: 10px;
                                        font-size: 14px;color:@white;width: 33.33%;
                                    }
                                }
                            }
                            
                        }
                        .main_2_2_2_2{
                            .flex-between();flex-flow: column;width:34.52%;height:100%;
                            .title {
                                height: 10%;
                                .flex-center();
                                
                                img{display: block;height:26px;width: auto;}
                            }
                            .main_2_2_2_2_1{
                                width:100%;
                                height: 48%;
                                padding:6% 0 0 0;box-sizing: border-box;
                                background: url(../../assets/main_2_2_2_2_1.png) no-repeat center;background-size:100% 100%;
                                .main {
                                    width:100%;
                                    padding: 1% 0;
                                    height: 85%;
                                    .flex-center();
                                    box-sizing: border-box;
                                }
                                .content {
                                    height: 90.6%;
                                    padding: 0 20px;
                                    .main {
                                        padding: 1% 0;
                                        height: 100%;
                                        box-sizing: border-box;
                                    }
                                }
                            
                            }
                            .main_2_2_2_2_2{
                                width:100%;
                                height: 51%;
                                padding:8% 0 0% 0;box-sizing: border-box;
                                background: url(../../assets/main_2_2_2_2_2.png) no-repeat center;background-size:100% 100%;
                                .main {
                                    width:100%;
                                    padding: 1% 0;
                                    height: 85%;
                                    .flex-center();
                                    box-sizing: border-box;
                                }
                                .content {
                                    height: 90.6%;
                                    padding: 0 10px;
                                    .main {
                                        padding: 1% 0;
                                        height: 100%;
                                        box-sizing: border-box;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .textlist {
                .flex-start();
                height: 100%;
                li {
                    width: 20%;
                    height: 100%;
                    border-radius: 4px;
                    padding: 0 0 0 ;
                    box-sizing: border-box;
                    .flex-start();
                    .picture{
                        width:100px;height: 100px;
                        position: relative;
                        .img1{position: absolute;top: 0;left:0;width: 100%;height:100%;animation: roate 3s infinite linear;}
                        img{
                            display: block; width: 100%;height:100%;
                        }
                    }
                    .info{
                        margin:0 0 0 15px;
                        .flex-start();
                        flex-flow: column;
                        align-items: flex-start;
                        justify-content: space-around;
                        span {
                            color: #45E8F7;
                            font-size: 24px;
                            font-weight: bold;
                        }
                        p {
                            margin-top: 5px;
                            display: block;
                            color: white;
                            font-size: 14px;
                        }
                    }
                    &:last-child{
                        width: 300px;
                    }
                }
            }    
            .textlist2{
                height: 100%;
                li{
                    
                    cursor: pointer;
                    margin-top:5px;
                    border-radius: 15px;
                    padding: 0 10px;
                    
                    .flex-between();
                    .info{
                        .flex-start();
                        width:40%;
                       span{
                           font-size: 14px;
                           color: #fff;
                           margin-right: 20px;
                       }
                       p{
                           font-size: 14px;
                           color: @white;  
                           text-overflow: ellipsis;overflow: hidden;white-space: nowrap;
                       }
                    }
                    .thingregcode{
                        font-size: 16px;
                        color: @white;
                        width:30%;
                        text-align: center;
                    }
                    .thingstatus{
                        font-size: 14px;
                        color: @white;
                        width:30%;
                        text-align: right;
                        .flex-end();
                        b{
                            width: 8px;
                            height: 8px;
                            margin-right: 8px;
                            background: white;
                            border-radius: 50%;
                        }
                        &.n10{
                            color: #55F8D7;
                            b{
                                background: #55F8D7;
                            }
                        }
                        &.n15{
                            color: #F8B655;
                            b{
                                background: #F8B655;
                            }
                        }
                        &.n17{
                            color: #00C734;
                            b{
                                background: #00C734;
                            }
                        }
                        &.n18{
                            color: #0BB5EB;
                            b{
                                background: #0BB5EB;
                            }
                        }
                        &.n20{
                            color: #44CA90;
                            b{
                                background: #44CA90;
                            }
                        }
                        &.n1{
                            color: #E55563;
                            b{
                                background: #E55563;
                            }
                        }
                    }
                    &.titlelist{
                        height: 100%;
                        margin: 0;
                    }
                    &:nth-child(odd){
                        background: linear-gradient(90deg, #1445A8 0%, rgba(20,69,168,0) 100%);
                    }
                    &.on1{
                         background: linear-gradient(90deg, #F69300 0%, rgba(246,147,0,0) 100%);
                    }
                    &.on2{
                        background: linear-gradient(90deg, #F6C44C 0%, rgba(246,147,0,0) 100%);
                    }
                    &.on3{
                        background: linear-gradient(90deg, #F6C44C 0%, rgba(246,147,0,0) 100%);
                    }
                }
                &.textlist2no{
                    li{
                        .info{
                           p{
                               color: #F69300;  
                           }
                        }
                        .thingregcode{
                            color: #F69300;  
                        }
                        .thingstatus{
                            color: #F69300;  
                        }
                    }
                    
                }
            }
            
            .empty{
                .flex-center();flex-flow: column;height:100%;
                img{width:148px;display: block;}
                p{margin:20px 0 0 0;color:#fff;font-size: 20px;}
            }
            
        }
        .infowindow{
            padding:0.2rem 0.2rem;
            background: linear-gradient(180deg, rgba(5,24,64,0.8) 0%, rgba(20,69,168,0.8) 100%);
            box-shadow: inset 0px 0px 24px 1px #4482FF;border-radius: 5px;
            border-radius: 0.1rem;
            position: relative;
            p{
                font-size: 0.32rem;
                text-align: center;
                color:@white;
            }    transform: translate(-50%,100%);
        } 
        .container{
            width:100%;height:100%;
            a{display: none;}
            .logo-text{display: none;}
            canvas{opacity: 0.8 !important;}
        }
    }
    ::v-deep{
        .van-tabs.van-tabs--line{
            padding:0;
            height: 100%;
            .van-tabs__wrap{
                height: 10.87%;
                position: relative;
                .van-tabs__nav{
                    padding:0;
                    box-sizing: border-box;
                }
                &::after{
                width:1px;height:24px;background: #86A9D6;position: absolute;left:50%;top:50%;transform: translate(-50%,-50%);content:'';
               }
                position: relative;
                box-sizing: border-box;
                // &::after{
                //     position:absolute;content: '';left:0;top:0;width: 58px;height: 58px; background: url('../../assets/tpf/borderL.png') no-repeat;background-size: 58px 58px;
                // }
                // &::before{
                //     position:absolute;content: '';right:0;bottom:0;width: 58px;height: 58px; background: url('../../assets/tpf/borderR.png') no-repeat;background-size: 58px 58px;
                // }
            }
            .van-tabs__content{
                padding: 0 0 20px 0;
                height: 89.13%;
                box-sizing: border-box;
                .van-tab__pane{
                    height: 100%;
                }
            }
            .van-tabs__line {
               // height: 92.4%;
            }
            .van-tab{
                height: 100%;
                .van-tab__text{
                    color: #00B6EF;font-size: 20px;
                }
                
                &.van-tab--active{
                    .van-tab__text{
                        color: #fff;font-size: 26px;font-weight: bold;
                    }
                }
            }
        }
        .textlist3{
            
            li{
                .flex-between();margin:10px 0;padding: 5px 0;
                span{
                   width:12%;color:#fff;font-size:14px !important;text-align: center;
                   &:nth-child(1){
                       width:24%;
                   }
                   &:nth-child(2){
                       width:20%;
                   }
                   &:nth-child(3){
                       width:20%;
                   }
                }
            }
        }
    }
    
</style>
